import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import NumberFormat from 'react-number-format';
import * as actions from '../action';
import * as c from '../constant';

function UpdateAmountModal({
  data,
  id,
  formData,
  setFormData,
  createTextArea,
  updateAmount,
  updatingAmount,
  showTransaction,
}) {
  const setModal = useContext(ModalContext);

  const OnSetFormData = () => {
    setFormData({
      amount: _.get(data, 'attributes.amount') || '',
    });
  };

  useEffect(() => {
    if (!_.isEmpty(data)) {
      OnSetFormData();
    }
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    updateAmount(id, formData, () => {
      setModal({ isOpen: false });

      showTransaction(id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">Amount:</label>
            <NumberFormat
              name="amount"
              id="amount"
              placeholder="0"
              className="form-control"
              onValueChange={values => {
                setFormData({
                  ...formData,
                  amount: values.value,
                });
              }}
              displayType="input"
              prefix=""
              value={_.get(formData, 'amount') || ''}
            />
          </div>
          <div className='col-12 form-group'>
            <label className="full-label mb-0">
              Remarks:
            </label>
            {createTextArea(
              { key: 'remarks' },
              { maxLength: '500', rows: '10' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updatingAmount}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {updatingAmount ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updatingAmount}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateAmountModal.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  updateAmount: PropTypes.instanceOf(Function).isRequired,
  updatingAmount: PropTypes.bool.isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updatingAmount: api.loading.indexOf(c.UPDATE_AMOUNT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateAmountModal);
